"use strict";
exports.__esModule = true;
function uqnSplit(u) {
    var stringArray = u.toString().split("");
    var numberArray;
    numberArray = [];
    stringArray.forEach(function (e) {
        numberArray.push(Number(e));
    });
    return numberArray;
}
exports["default"] = uqnSplit;
